export default {
    indexUnsanitaryType:    { method: 'get',    url: 'unsanitary_types' },
    createUnsanitaryType:   { method: 'post',   url: 'unsanitary_types' },
    updateUnsanitaryType:   { method: 'put',    url: 'unsanitary_types/{id}' },
    deleteUnsanitaryType:   { method: 'delete', url: 'unsanitary_types/{id}' },
}